export default "__VITE_ASSET__BMQeshtE__"